import type { OnboardingStatus, OnboardingStepStatus } from '@catalyst-psa/shared';
import {
  ONBOARDING_PHASE_LABELS,
  ONBOARDING_STATUS_LABELS,
  ONBOARDING_STEP_STATUS_LABELS,
} from '@catalyst-psa/shared';
import type { OnboardingPhase } from '@catalyst-psa/shared';

import type { Badge } from '../../components/ui/Badge.js';

type BadgeTone = NonNullable<Parameters<typeof Badge>[0]['tone']>;

export const ONBOARDING_STATUS_TONES: Record<OnboardingStatus, BadgeTone> = {
  in_progress: 'amber',
  complete: 'green',
};

export const ONBOARDING_PHASE_TONES: Record<OnboardingPhase, BadgeTone> = {
  systems_setup: 'gray',
  in_implementation: 'amber',
  ready_to_bill: 'blue',
  live: 'green',
};

export const ONBOARDING_STEP_STATUS_TONES: Record<OnboardingStepStatus, BadgeTone> = {
  pending: 'gray',
  completed: 'green',
  skipped: 'blue',
};

export { ONBOARDING_PHASE_LABELS, ONBOARDING_STATUS_LABELS, ONBOARDING_STEP_STATUS_LABELS };
